import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Form, Select, Tag } from 'antd';

const CareGuidePartnerTagInput = ({
  name,
  disabled = false,
  partnershipId,
  load,
  options,
  placeholder,
  label = null,
  rules = [],
  defaultLimit,
  defaultOrder,
  filter = {},
  ...props
}) => {
  // load tags on mount
  useEffect(() => {
    if (partnershipId) {
      load(partnershipId, 1, defaultLimit, defaultOrder, filter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, partnershipId]);

  const careGuidePartnerTagMap = new Map(options.map((y) => [y.id, y]));

  const tagRender = (props) => {
    const { value, label, closable, onClose } = props;
    const tagColor = value
      ? careGuidePartnerTagMap.get(value)?.color_hex
      : 'blue';

    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag
        color={tagColor}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3,
        }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <Form.Item
            name={name || 'cognito_forms_care_guide_partner_tags'}
            rules={rules}
            label={t(label)}
          >
            <Select
              showSearch
              optionFilterProp='children'
              disabled={props.isLoading || props.isSubmitting}
              loading={props.isLoading}
              placeholder={placeholder || t('care_guide_partner_tag_label')}
              maxTagCount={6}
              tagRender={tagRender}
              mode='multiple'
            >
              {options.map((x) => (
                <Select.Option key={x.id} value={x.id}>
                  {x.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default CareGuidePartnerTagInput;
